<template>
  <div>
    <v-card class="pa-4">
      <div class="text-xs-right">
        <v-btn @click="close" icon ripple class="primary">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="mb-4">
        <h5 class="mb-2">All voucher codes</h5>
        <div style="font-size: 14px" class="primary--text">
          <span style="font-weight: 700">Topic:</span> {{ selectedData.intentname }}
        </div>
      </div>
      <div class="mb-4">
        <v-layout wrap>
          <v-flex xs12 sm6>
            <div>
              <v-pagination
                :total-visible="6"
                v-model="pageNumber"
                @input="changePage"
                :length="pagelength"
              ></v-pagination>
            </div>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
            <exportxlsx
              :promisedValue="getXlsxData"
              :filename="selectedData.intentname"
            ></exportxlsx>
          </v-flex>
        </v-layout>
      </div>

      <v-data-table
        :headers="headers"
        :items="dataAllCodes"
        hide-actions
        :loading="loading"
        class="elevation-1"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.used ? 'ใช้งานแล้ว' : 'ยังไม่ได้ใช้' }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import importxlsx from '@/components/elements/importxlsx.vue'

export default {
  props: ['selectedData'],
  components: {
    exportxlsx,
    importxlsx
  },
  data() {
    return {
      loading: false,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      total: 0,
      headers: [
        { text: 'Codes', value: 'code', sortable: false },
        { text: 'Status', value: 'used', sortable: true }
      ],

      dataAllCodes: [],
      isExport: false,
      importloading: false
    }
  },
  created() {
    if (this.selectedData) {
      let intentName = this.selectedData.intentname
      this.getAllCode(intentName)
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    getAllCode(payload) {
      return new Promise(async (resolve) => {
        var vm = this
        var data = {
          pageid: vm.selectedBot.pageid,
          intentname: payload
        }

        if (vm.isExport) {
          Object.assign(data, {
            limit: vm.total,
            offset: 0
          })
        } else {
          Object.assign(data, {
            limit: vm.limit,
            offset: vm.offset
          })
        }

        vm.loading = true
        api.postPlernGetCode(data, (err, response) => {
          if (response.responsecode == 200) {
            vm.dataAllCodes = response.data
            vm.total = response.total
            vm.loading = false

            resolve(response.data)
          } else {
            console.log(err)
            return
          }
        })
      })
    },
    onImport(item) {
      this.importloading = true
      let intent = this.selectedData.intentname
      var data = {
        pageid: this.selectedBot.pageid,
        import_date: this.selectedData.import_date,
        intentname: intent,
        data: item[0]
      }
      api.postPlernImportCurrentGroup(data, async (err, response) => {
        this.importloading = false
        if (response && response.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          this.getAllCode(intent)
        } else {
          await this.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      })
    },
    getXlsxData() {
      return new Promise(async (resolve) => {
        this.isExport = true
        let intent = this.selectedData.intentname
        var data = await this.getAllCode(intent)

        resolve(
          data.map((el) => {
            return {
              Codes: el.code,
              Status: el.used ? 'ใช้งานแล้ว' : 'ยังไม่ได้ใช้งาน'
            }
          })
        )

        this.isExport = false
        this.getAllCode(intent)
      })
    },
    changePage(val) {
      var vm = this
      if (vm.pagetmp == val) {
        //dont do shit
      } else {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit

        let intent = this.selectedData.intentname
        this.getAllCode(intent)
      }
    },
    close() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.total = 0
      this.$emit('close')
    }
  }
  // watch: {
  //  'selectedData' :{
  //     handler(newVal,oldVal) {
  //       alert('xx')
  //       if(newVal !== oldVal && newVal !== '') {
  //         this.loading = false;
  //         this.dataAllCodes = [];
  //         this.offset = 0;
  //         this.pagetmp = 1;
  //         this.pageNumber = 1;
  //         this.total = 0;
  //         this.getAllCode(newVal.intentname);
  //       }
  //     },
  //     deep: true
  //   },
  // },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/plern/AllCodeModal.vue